import React from 'react';

const Home = () =>
  <div className="home">
    <h1>The Development Archives of Brandon Oden</h1>
  </div>;

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js